// extracted by mini-css-extract-plugin
module.exports = {"link":"_1jFRj","image":"_10_mv","root":"novgM"};